import { render, staticRenderFns } from "./printTicket.vue?vue&type=template&id=65b3b104&scoped=true&"
import script from "./printTicket.vue?vue&type=script&lang=js&"
export * from "./printTicket.vue?vue&type=script&lang=js&"
import style0 from "./printTicket.vue?vue&type=style&index=0&id=65b3b104&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b3b104",
  null
  
)

export default component.exports